import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ConditionsHttpService } from './conditions-http.service';
import { ConditionsActions } from './conditions.store';

@Injectable({ providedIn: 'root' })
export class ConditionsEffects {
  public loadConditions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ConditionsActions.fetchCollection),
      mergeMap(({ payload }) =>
        this.conditionsHttpService.loadConditions().pipe(
          map(data =>
            ConditionsActions.fetchCollectionSuccess({
              payload: { data },
            }),
          ),
          catchError(error => of(ConditionsActions.fetchCollectionFailed({ payload: error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private conditionsHttpService: ConditionsHttpService,
  ) {}
}
